var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1019,
    viewBox: "0 0 1512 1019",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 970.467C289 1051.97 602.5 1023.97 788 891.467C973.5 758.967 1045.39 623.5 1209.5 560.008C1331 513 1458.5 565.5 1515.5 598.495",
    stroke: "#FE8F30",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1517 876.5C1320 680 1081.5 730.5 860.5 769.5C639.5 808.5 501 658 340.5 660.5C212.1 662.5 60 753.667 0 799",
    stroke: "#CCDDE2",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 445C239.354 410.888 347.748 247.745 560.019 234.891C787.236 221.132 927.857 326.158 1098.98 280.868C1270.1 235.577 1289 55 1517.5 5.50195",
    stroke: "#CCDDE2",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 396C101.955 439.551 130.591 363.653 215.897 336.568C371.824 287.06 410.241 363.944 533.748 356.11C670.684 347.425 666.613 293.407 735.653 216.272C830.109 110.742 895.079 140.273 988.535 97.2789C1033.02 76.813 1062.5 34.3082 1062.5 0",
    stroke: "#FE8F30",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLines);
export default __webpack_public_path__ + "static/media/bg_lines.278b6fc8872bba84d4fcaf958ef31ec9.svg";
export { ForwardRef as ReactComponent };